import React from 'react';
import SimpleHero from '../../components/SimpleHero/SimpleHero';
import FeatureList from '../../components/Minimal/FeatureList';
import app from "../../assets/images/apple.png"
import google from "../../assets/images/google.png"
import moneytransfer from "../../assets/images/transference.png"
import deposit from "../../assets/images/deposit.png"
import bank from "../../assets/images/mobilebanking.png"
import "./MobilePayment.css"

const MobileBankingPage = () => {
  return (
    <div>
      <SimpleHero
        title="Your bank, in your pocket"
        subtitle="Check balances, transfer money, and deposit checks from anywhere."
        primaryLabel="Get the app"
        primaryHref="/download"
        variant="sofi"
        imageSrc={bank}
        imageAlt="Mobile banking"
        imageOn="right"
        tiltImage
        badges={["Account management","Transfers","Mobile deposit"]}
      />
      <FeatureList
        items={[
          { icon: bank, title: 'Account management', desc: 'Balances, transactions and more.' },
          { icon: moneytransfer, title: 'Transfers & payments', desc: 'Send, receive, and pay bills.' },
          { icon: deposit, title: 'Mobile deposit', desc: 'Snap and deposit checks.' },
        ]}
      />
      <section className="section text-center">
        <div className="gn-container">
          <img src={app} alt="App Store" />
          <img src={google} alt="Google Play" />
        </div>
      </section>
    </div>
  );
};

export default MobileBankingPage;
